import { c as _c } from "react/compiler-runtime";
import * as ToastPrimitive from '@radix-ui/react-toast';
import LinkButton from '../../../link-button';
type ActionButtonProps = {
  children: string;
  onClick?: () => void;
  altText: string;
};
const ActionButton = t0 => {
  const $ = _c(6);
  const {
    children,
    onClick,
    altText
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== onClick) {
    t1 = <LinkButton onClick={onClick}>{children}</LinkButton>;
    $[0] = children;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== altText || $[4] !== t1) {
    t2 = <ToastPrimitive.Action asChild={true} altText={altText}>{t1}</ToastPrimitive.Action>;
    $[3] = altText;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default ActionButton;